import { createEffect, createSignal } from "solid-js";
import { LoadingButton } from "../../components/ui/Button";
import { TextInput } from "../../components/ui/form/TextInput";
import { Modal } from "../../components/ui/Modal";
import { DialogFooter } from "@/components/shadcn/dialog";
import usePatient from "../../services/usePatient";

export const PatientModal = (props) => {

  const [open, setOpen] = createSignal(false);
  const [title, setTitle] = createSignal('');
  const onClose = (state) => {
    if (typeof props.onClose === 'function') {
      props.onClose();
    }
  }

  const onRefresh = () => {
    if (typeof props.onRefresh === 'function') {
      props.onRefresh();
    }
  }

  const {
    form,
    handleChange,
    handleSave,
    fetchInfo,
    loading,
    fetching,
    clearForm,
  } = usePatient({ onClose, onRefresh });

  createEffect(() => {
    props.open;
    setOpen(props.open);
  });

  createEffect(() => {
    props.key;
    if (props.key !== null) {
      fetchInfo(props.key);
      setTitle('Edit Patient');
    } else {
      clearForm();
      setTitle('New Patient');
    }
  });

  return (
    <Modal
      open={open()}
      title={title()}
      onClose={onClose}
      fetching={fetching()}
      hideOnOutsideClick={false}
      error={''}
    >
      <div class="grid grid-cols-2 gap-2">
        <div class="grid gap-1">
          <TextInput
            label="NAME"
            name="name"
            form={form}
            input={handleChange}
          />
        </div>
        <div class="col-span-2">
            <SelectInput
              label="Gender"
              name="gender"
              form={form}
              options={genders()}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <DateInput
              label="Birth Date"
              name="birthDate"
              form={form}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <SelectInput
              label="Blood Group"
              name="bloodGroup"
              form={form}
              options={bloodGroups()}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <SelectInput
              label="Type"
              name="type"
              form={form}
              options={types()}
              input={handleInput}
            />
          </div>
          <Show when={showAssociate()}>
            <div class="col-span-4">
              <TextInput
                label="Associate Person"
                name="associateName"
                form={form}
                input={handleInput}
              />
            </div>
          </Show>
          <div class="col-span-2">
            <TextInput
              label="Cnic"
              name="cnic"
              form={form}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <TextInput
              label="Phone"
              name="phone"
              form={form}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <TextInput
              label="Email"
              name="email"
              form={form}
              input={handleInput}
            />
          </div>
      </div>
      <DialogFooter>
        <LoadingButton variant="outline" onClick={() => { handleSave() }} type="button" loading={loading()} disabled={fetching()}>Save</LoadingButton>
      </DialogFooter>
    </Modal>
  );
}
